<template lang="pug">
  div.e-simple-file-uploader
    div(
    v-if="loading"
    ).loading Загрузка...
    div(
    v-else-if="!readOnly && model[name] && model[name].id"
    ref="input"
    ).preview-file
      div.name {{model[name].name}}
      div.size {{((model[name].size || 1) / 1024 / 1024).toFixed(2)}} Мб
      div.remove
        a(
        href="#"
        @click.prevent.self="removeFile"
        ) Удалить
    div(
    v-else
    ).upload-file
      label(
        v-if="!readOnly"
      )
        input(
        ref="input"
        type="file"
        @change="onChange"
        )
        a(@click.stop.prevent="").caption Прикрепить файл
    div
      div(
      v-if="uploadError"
      ).error Ошибка загрузки: {{uploadError}}

    div(v-if="showFilePreview && previewError")
      div.error Ошибка предпросмотра: {{previewError}}

    div(v-if="readOnly || showPreview")
      div(
        v-if="filePreviewImage.isOnRemoteServer && filePreviewImage.url"
        @click.stop.prevent="downloadAndSaveFile()"
        :title="$translate('Скачать')"
      ).image-preview-wrapper.with-actions
        img(
        :src="imagePreview"
        )
      div(
        v-else-if="filePreviewImage.isOnRemoteServer"
        @click.stop.prevent="downloadAndSaveFile()"
        :title="$translate('Скачать')"
      ).image-preview-wrapper.with-actions
        div.default-icon-wrapper
          div.default-icon

</template>

<script>
  import userFriendlyEr from '../../utils/userFriendlyEr.js'
  import permissionMixin from '../../mixins/permission-mixin.js'
  import saveFile from '../../utils/saveFile'
  import { ROOT_API, ROOT_DOMAIN } from '@/config/config'
  import store from '../../store'

  // 1px transparent gif
  const TRANSPARENT_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

  const DOWNLOADING_GIF = TRANSPARENT_GIF

  export default {
    name: 'e-simple-file-uploader',
    mixins: [permissionMixin],
    data: () => ({
      uploadError: null,
      error: null,
      loading: false,
      downloadedFiles: {},
      previewError: null
    }),
    props: {
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null,
        required: true
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      required: {
        type: Boolean,
        default: false
      },
      uploadUrl: {
        type: Function,
        default: function () {
          return null
        }
      },
      modalVariableName: {
        type: String,
        default: null
      },
      showFilePreview: {
        type: Boolean,
        default: false
      },
      previewNeedDownload: {
        type: Boolean,
        default: true
      },
      // (remote | attachToForm)
      uploadType: {
        type: String,
        default: 'remote'
      },
      previewExt: {
        type: Array,
        default: function () {
          return ['png', 'jpg', 'jpeg', 'bmp', 'gif']
        }
      },
      readOnly: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      imagePreview () {
        let fP = this.filePreviewImage
        let files = this.downloadedFiles
        if (fP.url) {
          if (files[fP.url]) {
            return files[fP.url]
          } else {
            setTimeout(() => {
              this.downloadPreview(fP.url)
            }, 0)
          }
        }
        return TRANSPARENT_GIF
      },
      showPreview () {
        return this.showFilePreview && !this.loading && !this.uploadError
      },
      filePreviewImage () {
        let url = null
        let downloadUrl = null
        let isOnRemoteServer = false
        let name = ''

        if (this.model[this.name] && this.model[this.name].url) {
          if (this.model[this.name].url[0] === '/') {
            this.model[this.name].url = this.model[this.name].url.substring(1)
          }
          isOnRemoteServer = true
          const ROOT_URL = this.model[this.name].url.includes('storage') ? ROOT_DOMAIN : ROOT_API
          const ext = this.model[this.name].url.includes('storage') ? '.' + this.previewExt : ''
          downloadUrl = ROOT_URL + this.model[this.name].url
          name = this.model[this.name].name || ''
          if (this.previewExt.indexOf(this.model[this.name].ext.toString().toLowerCase()) > -1) {
            url = ROOT_URL + this.model[this.name].url + ext
          }
        }
        return {url, downloadUrl, isOnRemoteServer, name}
      },
      fileAttached () {
        return this.model[this.name]
      },
      getPlaceholder () {
        if (this.placeholder === null) {
          return ''
        }
        return this.placeholder
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
      if (!this.$store) {
        this.$store = store
      }
    },
    methods: {
      downloadAndSaveFile () {
        const fP = this.filePreviewImage
        if (fP.downloadUrl) {
          const fileName = fP.name
          const endpoint = fP.downloadUrl

          let parts = endpoint.split('.')
          // remove ext for disable servers nginx problem
          parts = parts.slice(0, -1)

          this.$bar.start()
          this.$store.dispatch('downloadFile', {
            endpoint: parts.join('.'),
          }).then(r => {
            this.$bar.finish()
            saveFile({
              blob: r.request.response,
              fileName
            })
          }).catch(e => {
            this.$bar.finish()
            this.$e.errorBox(e)
          })
        }
      },
      downloadPreview (endpoint) {
        // set preloader
        this.$set(this.downloadedFiles, endpoint, DOWNLOADING_GIF)
        let parts = endpoint.split('.')
        // remove ext for disable servers nginx problem
        parts = parts.slice(0, -1)
        this.previewError = null
        this.$store.dispatch(
          'downloadFile',
          {
            endpoint: parts.join('.'),
            params: {
              disableAuthError: true
            }
          }
        ).then(r => {
          let blob = r.request.response
          let reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onloadend = () => {
            this.$set(this.downloadedFiles, endpoint, reader.result)
          }
        }).catch(e => {
          this.previewError = 'Не удалось загрузить предпросмотр изображения: ' + userFriendlyEr.recognize(e)
        })
      },
      validate () {
        let msg = ''
        if (this.required) {
          if (!this.model[this.name] || !this.model[this.name].id) {
            msg = 'Загрузите файл'
          }
        }
        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement()
        }
      },
      getElement () {
        return this.$refs.input
      },
      onChange (e) {
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }

        if (!this.userCanWrite) {
          this.$e.errorBox('Нет прав на добавление файла')
          return
        }

        for (let file of files) {
          if (this.uploadType === 'attachToForm') {
            this.attachToForm(file)
          } else {
            this.uploadFile(file)
          }
          break
        }
      },
      removeFile () {
        if (!this.userCanDelete) {
          this.$e.errorBox('Нет прав на удаление файла')
          return
        }

        this.previewError = null
        this.$emit('fileRemoved', JSON.parse(JSON.stringify(this.model[this.name])))
        // this.model[this.name] = Object.create(null)
        this.$set(this.model, this.name, Object.create(null))
      },
      attachToForm (file) {
        this.loading = false
        this.uploadError = null
        this.previewError = null
        const uploadedMock = {
          name: file.name,
          size: file.size,
          id: 'mock',
          file
        }
        this.$emit('fileUploaded', uploadedMock)
        this.$set(this.model, this.name, Object.assign({}, uploadedMock))
      },
      uploadFile (file) {
        if (this.uploadUrl && this.uploadUrl()) {
          this.loading = true
          this.uploadError = null
          this.previewError = null
          this.$sharedServices.store.dispatch('uploadFile', {
            url: this.uploadUrl(),
            data: {
              'upload': file
            }
          }).then(r => {
            this.$emit('fileUploaded', r)
            this.$set(this.model, this.name, Object.assign({}, r))
            // this.model[this.name] = Object.assign({}, r)
            this.loading = false
          }).catch(e => {
            console.error(e)
            this.loading = false
            this.uploadError = userFriendlyEr.recognize(e)
          })
        }
      }
    }
  }
</script>
